import { Content } from "src/shared/components/content";

export const Covered = () => (
  <svg version="1.1" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <title>
      <Content id="cid$#2984766#" />
    </title>
    <defs>
      <circle id="a" cx="100" cy="100" r="100" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-900 -292)">
        <g transform="translate(900 292)">
          <mask id="b" fill="white">
            <use xlinkHref="#a" />
          </mask>
          <use fill="#E8F4D9" xlinkHref="#a" />
          <g mask="url(#b)" strokeLinecap="round" strokeLinejoin="round">
            <g transform="translate(53 65)">
              <g stroke="#264A19" strokeWidth="4.0602">
                <polyline id="Path" points="0 29.742 11.653 46.796 24.971 30.99" />
                <polyline id="Path" points="94.286 45.218 82.174 28.059 69.279 44.209" />
                <path
                  id="Path"
                  d="m82.029 29.118c3.3376 18.346-9.5958 36.276-27.118 40.445-12.099 3.3357-24.615-0.83392-32.959-9.1732"
                />
                <path
                  id="Path"
                  d="m12.664 45.756c-5.2775-20.366 8.1192-40.316 26.388-44.888 12.991-2.9094 25.576 1.6625 34.101 11.222"
                />
              </g>
              <g transform="translate(33.797 16.807)" stroke="#8CC63F" strokeWidth="3.6911">
                <polygon id="Path" points="26.485 15.126 0 15.126 0 34.034 26.485 34.034" />
                <path
                  id="c"
                  d="m3.7835 9.4539c0-5.2941 4.1619-9.4539 9.4589-9.4539 5.297 0 9.4589 4.1597 9.4589 9.4539v5.6722h-18.918v-5.6722z"
                />
                <line x1="13.242" x2="13.242" y1="22.689" y2="26.471" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
